import { Flex, Heading, Text } from "@unifize/sarah";

const Header = () => {
  return (
    <header style={{ marginBottom: "2rem" }}>
      <Flex
        justify="flex-start"
        items="center"
        style={{
          gap: "0.75rem",
          marginBottom: "2rem",
        }}
      >
        <Text variant="body" weight="regular" color="#101828">
          Unifize
        </Text>
        <Text variant="caption" weight="regular" color="#667085">
          for Azure Marketplace
        </Text>
      </Flex>
      <Flex direction="column" justify="center" items="center">
        <Heading variant="h6">Welcome to Unifize - Azure Marketplace</Heading>
      </Flex>
    </header>
  );
};

export default Header;
